import { render, staticRenderFns } from "./hy_policy.vue?vue&type=template&id=bc246c7a&scoped=true&"
import script from "./hy_policy.vue?vue&type=script&lang=js&"
export * from "./hy_policy.vue?vue&type=script&lang=js&"
import style0 from "./hy_policy.vue?vue&type=style&index=0&id=bc246c7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc246c7a",
  null
  
)

export default component.exports